import { render, staticRenderFns } from "./HeaderSideBar.vue?vue&type=template&id=72479940"
import script from "./HeaderSideBar.vue?vue&type=script&lang=js"
export * from "./HeaderSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports